/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.sync.subscribeRepos'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
})

export type $Params = l.InferOutput<typeof $params>

export const $message = /*#__PURE__*/ l.typedUnion(
  [
    /*#__PURE__*/ l.typedRef<Commit>((() => commit) as any),
    /*#__PURE__*/ l.typedRef<Sync>((() => sync) as any),
    /*#__PURE__*/ l.typedRef<Identity>((() => identity) as any),
    /*#__PURE__*/ l.typedRef<Account>((() => account) as any),
    /*#__PURE__*/ l.typedRef<Info>((() => info) as any),
  ],
  false,
)

export type $Message = l.InferOutput<typeof $message>

/** Repository event stream, aka Firehose endpoint. Outputs repo commits with diff data, and identity update events, for all repositories on the current server. See the atproto specifications for details around stream sequencing, repo versioning, CAR diff format, and more. Public and does not require auth; implemented by PDS and Relay. */
const main = /*#__PURE__*/ l.subscription($nsid, $params, $message, [
  'FutureCursor',
  'ConsumerTooSlow',
])

export { main }

export const $lxm = $nsid

/** Represents an update of repository state. Note that empty commits are allowed, which include no repo data changes, but an update to rev and signature. */
type Commit = {
  $type?: 'com.atproto.sync.subscribeRepos#commit'

  /**
   * The stream sequence number of this message.
   */
  seq: number

  /**
   * @deprecated unused
   */
  rebase: boolean

  /**
   * @deprecated replaced by #sync event and data limits. Indicates that this commit contained too many ops, or data size was too large. Consumers will need to make a separate request to get missing data.
   */
  tooBig: boolean

  /**
   * The repo this event comes from. Note that all other message types name this field 'did'.
   */
  repo: l.DidString

  /**
   * Repo commit object CID.
   */
  commit: l.Cid

  /**
   * The rev of the emitted commit. Note that this information is also in the commit object included in blocks, unless this is a tooBig event.
   */
  rev: l.TidString

  /**
   * The rev of the last emitted commit from this repo (if any).
   */
  since: l.TidString | null

  /**
   * CAR file containing relevant blocks, as a diff since the previous repo state. The commit must be included as a block, and the commit block CID must be the first entry in the CAR header 'roots' list.
   */
  blocks: Uint8Array
  ops: RepoOp[]
  blobs: l.Cid[]

  /**
   * The root CID of the MST tree for the previous commit from this repo (indicated by the 'since' revision field in this message). Corresponds to the 'data' field in the repo commit object. NOTE: this field is effectively required for the 'inductive' version of firehose.
   */
  prevData?: l.Cid

  /**
   * Timestamp of when this message was originally broadcast.
   */
  time: l.DatetimeString
}

export type { Commit }

/** Represents an update of repository state. Note that empty commits are allowed, which include no repo data changes, but an update to rev and signature. */
const commit = /*#__PURE__*/ l.typedObject<Commit>(
  $nsid,
  'commit',
  /*#__PURE__*/ l.object({
    seq: /*#__PURE__*/ l.integer(),
    rebase: /*#__PURE__*/ l.boolean(),
    tooBig: /*#__PURE__*/ l.boolean(),
    repo: /*#__PURE__*/ l.string({ format: 'did' }),
    commit: /*#__PURE__*/ l.cid(),
    rev: /*#__PURE__*/ l.string({ format: 'tid' }),
    since: /*#__PURE__*/ l.nullable(/*#__PURE__*/ l.string({ format: 'tid' })),
    blocks: /*#__PURE__*/ l.bytes({ maxLength: 2000000 }),
    ops: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<RepoOp>((() => repoOp) as any),
      { maxLength: 200 },
    ),
    blobs: /*#__PURE__*/ l.array(/*#__PURE__*/ l.cid()),
    prevData: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.cid()),
    time: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { commit }

/** Updates the repo to a new state, without necessarily including that state on the firehose. Used to recover from broken commit streams, data loss incidents, or in situations where upstream host does not know recent state of the repository. */
type Sync = {
  $type?: 'com.atproto.sync.subscribeRepos#sync'

  /**
   * The stream sequence number of this message.
   */
  seq: number

  /**
   * The account this repo event corresponds to. Must match that in the commit object.
   */
  did: l.DidString

  /**
   * CAR file containing the commit, as a block. The CAR header must include the commit block CID as the first 'root'.
   */
  blocks: Uint8Array

  /**
   * The rev of the commit. This value must match that in the commit object.
   */
  rev: string

  /**
   * Timestamp of when this message was originally broadcast.
   */
  time: l.DatetimeString
}

export type { Sync }

/** Updates the repo to a new state, without necessarily including that state on the firehose. Used to recover from broken commit streams, data loss incidents, or in situations where upstream host does not know recent state of the repository. */
const sync = /*#__PURE__*/ l.typedObject<Sync>(
  $nsid,
  'sync',
  /*#__PURE__*/ l.object({
    seq: /*#__PURE__*/ l.integer(),
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    blocks: /*#__PURE__*/ l.bytes({ maxLength: 10000 }),
    rev: /*#__PURE__*/ l.string(),
    time: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { sync }

/** Represents a change to an account's identity. Could be an updated handle, signing key, or pds hosting endpoint. Serves as a prod to all downstream services to refresh their identity cache. */
type Identity = {
  $type?: 'com.atproto.sync.subscribeRepos#identity'
  seq: number
  did: l.DidString
  time: l.DatetimeString

  /**
   * The current handle for the account, or 'handle.invalid' if validation fails. This field is optional, might have been validated or passed-through from an upstream source. Semantics and behaviors for PDS vs Relay may evolve in the future; see atproto specs for more details.
   */
  handle?: l.HandleString
}

export type { Identity }

/** Represents a change to an account's identity. Could be an updated handle, signing key, or pds hosting endpoint. Serves as a prod to all downstream services to refresh their identity cache. */
const identity = /*#__PURE__*/ l.typedObject<Identity>(
  $nsid,
  'identity',
  /*#__PURE__*/ l.object({
    seq: /*#__PURE__*/ l.integer(),
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    time: /*#__PURE__*/ l.string({ format: 'datetime' }),
    handle: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'handle' }),
    ),
  }),
)

export { identity }

/** Represents a change to an account's status on a host (eg, PDS or Relay). The semantics of this event are that the status is at the host which emitted the event, not necessarily that at the currently active PDS. Eg, a Relay takedown would emit a takedown with active=false, even if the PDS is still active. */
type Account = {
  $type?: 'com.atproto.sync.subscribeRepos#account'
  seq: number
  did: l.DidString
  time: l.DatetimeString

  /**
   * Indicates that the account has a repository which can be fetched from the host that emitted this event.
   */
  active: boolean

  /**
   * If active=false, this optional field indicates a reason for why the account is not active.
   */
  status?:
    | 'takendown'
    | 'suspended'
    | 'deleted'
    | 'deactivated'
    | 'desynchronized'
    | 'throttled'
    | l.UnknownString
}

export type { Account }

/** Represents a change to an account's status on a host (eg, PDS or Relay). The semantics of this event are that the status is at the host which emitted the event, not necessarily that at the currently active PDS. Eg, a Relay takedown would emit a takedown with active=false, even if the PDS is still active. */
const account = /*#__PURE__*/ l.typedObject<Account>(
  $nsid,
  'account',
  /*#__PURE__*/ l.object({
    seq: /*#__PURE__*/ l.integer(),
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    time: /*#__PURE__*/ l.string({ format: 'datetime' }),
    active: /*#__PURE__*/ l.boolean(),
    status: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: [
          'takendown',
          'suspended',
          'deleted',
          'deactivated',
          'desynchronized',
          'throttled',
        ]
      }>(),
    ),
  }),
)

export { account }

type Info = {
  $type?: 'com.atproto.sync.subscribeRepos#info'
  name: 'OutdatedCursor' | l.UnknownString
  message?: string
}

export type { Info }

const info = /*#__PURE__*/ l.typedObject<Info>(
  $nsid,
  'info',
  /*#__PURE__*/ l.object({
    name: /*#__PURE__*/ l.string<{ knownValues: ['OutdatedCursor'] }>(),
    message: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { info }

/** A repo operation, ie a mutation of a single record. */
type RepoOp = {
  $type?: 'com.atproto.sync.subscribeRepos#repoOp'
  action: 'create' | 'update' | 'delete' | l.UnknownString
  path: string

  /**
   * For creates and updates, the new record CID. For deletions, null.
   */
  cid: l.Cid | null

  /**
   * For updates and deletes, the previous record CID (required for inductive firehose). For creations, field should not be defined.
   */
  prev?: l.Cid
}

export type { RepoOp }

/** A repo operation, ie a mutation of a single record. */
const repoOp = /*#__PURE__*/ l.typedObject<RepoOp>(
  $nsid,
  'repoOp',
  /*#__PURE__*/ l.object({
    action: /*#__PURE__*/ l.string<{
      knownValues: ['create', 'update', 'delete']
    }>(),
    path: /*#__PURE__*/ l.string(),
    cid: /*#__PURE__*/ l.nullable(/*#__PURE__*/ l.cid()),
    prev: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.cid()),
  }),
)

export { repoOp }
